<div class="width-1100">

  <mat-card>

    <mat-toolbar class="toolbar-top">

      <div class='title'>
        <mat-icon>noise_control_off</mat-icon>
        <div>Carrossel</div>
      </div>

      <div flex justify-content='flex-end' fxLayoutAlign="end">

        <input class='filter' matInput (keyup)="applyFilter($event.target.value)" placeholder='filtro'
          autocomplete="off">

        <a mat-button (click)="openDialog(null)" matTooltip='Novo Doc' style="width:60px;">
          <mat-icon color='primary'>add_circle_outline</mat-icon>
        </a>
      </div>

    </mat-toolbar>
  </mat-card>

  <mat-card>
    <mat-form-field class="category-width" appearance="outline">
      <mat-label>Locais</mat-label>
      <mat-select (ngModelChange)='selectLocation($event)' [ngModel]="selectedLocation">
        <mat-option *ngFor="let location of locations" [value]="location">
          {{ location }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </mat-card>

  <mat-card>

    <!-- TABLE -->
    <mat-table [dataSource]="dataSource" matSort matSortActive="location" matSortDirection='asc'
      matSortDisableClear=true style='height: calc(100vh - 180px); overflow: auto;'>

      <!-- Icon Column -->
      <ng-container matColumnDef="icon">
        <mat-header-cell *matHeaderCellDef mat-sort-header> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-icon class="icon-dot">noise_control_off</mat-icon>
        </mat-cell>
      </ng-container>


      <!-- location Column -->
      <ng-container matColumnDef="location">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Local</mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ element.location }} </mat-cell>
      </ng-container>


      <!-- pçosition Column -->
      <ng-container matColumnDef="position">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Pos</mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ element.position }} </mat-cell>
      </ng-container>

      <!-- ImageBig Column -->
      <ng-container matColumnDef="imageBig">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Desktop </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <img style="height: 60px; margin: 5px;" [src]=element.srcBig>
        </mat-cell>
      </ng-container>

      <!-- ImageSmall Column -->
      <ng-container matColumnDef="imageSmall">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Mobile </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <img style="height: 60px; margin: 5px;" [src]=element.srcSmall>
        </mat-cell>
      </ng-container>

      <!-- dateIn Column -->
      <ng-container matColumnDef="dateIn">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Entrada </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ element.dateIn.seconds*1000 | date: "dd/MM/yyyy" }} </mat-cell>
      </ng-container>
      ]
      <!-- dateOut Column -->
      <ng-container matColumnDef="dateOut">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Saída </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ element.dateOut.seconds*1000 | date: "dd/MM/yyyy" }} </mat-cell>
      </ng-container>

      <!-- link Column -->
      <ng-container matColumnDef="link">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Link </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span *ngIf="element.link">{{ element.link.substring(0,50) }}</span>
        </mat-cell>
      </ng-container>

      <!-- edit Column -->
      <ng-container matColumnDef="edit">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <a mat-button (click)='openDialog(element)' matTooltip='Editar' style="background-color: whitesmoke;">
            <mat-icon class='icon-info'>
              info_outline
            </mat-icon>
          </a>
        </mat-cell>
      </ng-container>

      <!-- delete Column -->
      <ng-container matColumnDef="delete">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <a mat-button (click)='delete(element)' matTooltip='Apagar' style='background-color: whitesmoke;'>
            <mat-icon class='icon-delete' style="font-size:1.5em;">delete_outline
            </mat-icon>
          </a>
        </mat-cell>
      </ng-container>


      <!-- Header -->
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

      <!-- Row -->
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

    </mat-table>
    <!-- END TABLE -->

  </mat-card>

</div>